import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'primereact/button'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useHistory } from 'react-router-dom'

import { TParamFilterData } from './PrimeTableCustomHeader'

type TProps = { apiFilterArray: TParamFilterData[] }

export const PrimeTableCustomFilterSelection = ({ apiFilterArray }: TProps) => {
  const { t } = useTranslation()
  const { search } = useLocation()

  const history = useHistory()
  const urlSearchParams = useMemo(() => new URLSearchParams(search), [search])

  const removeDateRange = (filterName: string) => {
    urlSearchParams.delete(filterName)
    urlSearchParams.set('offset', '0')
    const newSearchParam = urlSearchParams.toString()
    history.push({
      pathname: window.location.pathname,
      search: decodeURIComponent(newSearchParam),
    })
  }

  return (
    <>
      {apiFilterArray.map(apiFilter => {
        return apiFilter.value ? (
          <Button
            key={apiFilter.name}
            onClick={() => removeDateRange(apiFilter.name)}>
            <FontAwesomeIcon icon={'xmark'} />
            {t(apiFilter.label || apiFilter.name)}
          </Button>
        ) : null
      })}
    </>
  )
}
